<template>
    <div class="container">
        <div class="banner-wrap">
            <BannerTop :comItem="detailmodel" />
        </div>
        <div class="content">
            <div class="competition-nav">
                <ul>
                    <li :class="[activePath=='/introduction'?'active':'']">
                        <router-link :to="{path: '/introduction', query:{id: id}}">赛事介绍</router-link>
                    </li>
                    <li :class="[activePath=='/time'?'active':'']">
                        <router-link :to="{path: '/time', query:{id: id}}">赛事日程</router-link>
                    </li>
                    <li :class="[activePath=='/prize'?'active':'']">
                        <router-link :to="{path: '/prize', query:{id: id}}">奖项配置</router-link>
                    </li>
                    <li :class="[activePath=='/expert'?'active':'']">
                        <router-link :to="{path: '/expert', query:{id: id}}">专家团队</router-link>
                    </li>
                    <li :class="[activePath=='/comVideo'?'active':'']">
                        <router-link :to="{path: '/comVideo', query:{id: id}}">大赛视频</router-link>
                    </li>
                </ul>
            </div>
            <div class="competition-cnt">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
<script>
import qs from 'qs'
import { post, ajaxParam } from '@/units/request.js'
import competitionModules from '@/modules/competition.js'
import BannerTop from '@/components/competition/bannerTop'
export default {
    name: 'competitionIndex',
    components: {
        BannerTop
    },
    mixins: [
        competitionModules
    ],
    data() {
        return {
            activePath: '/introduction',
            id: '', //大赛id
        }
    },
    watch: {
        $route(to, from) {
            let path = to.path
            this.activePath = path
        }
    },
    created() {
        this.id = this.$route.query.id
    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.banner-wrap {
    width: 1200px;
    margin: 0 auto;
}

.content {
    display: flex;
    width: 1200px;
    margin: 20px auto;
    padding: 20px;
    background: #fff;
    border-radius: 12px;
    box-sizing: border-box;

    .competition-nav {
        ul {
            li {
                width: 160px;
                height: 46px;
                font-size: 16px;
                color: var(--color-text-opacity);
                text-align: center;
                line-height: 46px;

                a {
                    display: block;
                }

                a:hover {
                    text-decoration: none;
                }
            }

            li.active {
                background: rgba(207, 23, 29, .1);
                font-weight: bold;
                font-size: 16px;
                color: var(--color-text);
            }
        }
    }

    /deep/ .competition-cnt {
        flex: 1;
        padding-left: 20px;
        border-left: 1px solid var(--color-border);

        video {
            max-width: 100%;
            max-height: 600px;
        }
    }
}
</style>